import { COMMON_DATE_FORMAT } from '@/constants';
import { format } from 'date-fns';

export const stringFromDateOrString = (value: Date | string | undefined): string | undefined => {
  if (value && value instanceof Date) {
    return format(value, COMMON_DATE_FORMAT);
  }
  return value;
};
